import { stringify } from "qs"
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import getBaseUrl from "./getBaseUrl"
import type { State as AuthState } from "@/auth/slice"
import { getTimeZone } from "@/utils"

const paramsSerializer = (params: Record<string, unknown>) => {
  const sanitizedParams: Record<string, unknown> = {}

  Object.keys(params).forEach((paramKey) => {
    const value = params[paramKey]

    // A (bool) cast or truthiness check in PHP reads "false" as true; "1"/"0" parse either way.
    if (value === true) {
      sanitizedParams[paramKey] = "1"
    } else if (value === false) {
      sanitizedParams[paramKey] = "0"
    } else if (value instanceof Date) {
      sanitizedParams[paramKey] = value.toISOString()
    } else {
      sanitizedParams[paramKey] = value
    }
  })

  return stringify(sanitizedParams, {
    arrayFormat: "brackets",
    skipNulls: true,
  })
}

const prepareCommonHeaders = (headers: Headers) => {
  headers.set("TimeZone", getTimeZone()) // Unused, but nice to have

  return headers
}

type BaseQueryOptions = {
  withoutAuth: boolean
}

export default ({ withoutAuth }: BaseQueryOptions) =>
  fetchBaseQuery({
    baseUrl: getBaseUrl(),
    prepareHeaders: (headers, { getState }) => {
      const { token, tenantSlug } = (getState() as { auth: AuthState }).auth

      if (!withoutAuth && token) {
        headers.set("Authorization", `Bearer ${token}`)
      }
      if (tenantSlug) {
        headers.set("Tenant-Slug", tenantSlug)
      }

      return prepareCommonHeaders(headers)
    },
    paramsSerializer,
  })
